/** /secrets after the Secrets screen was retired: points to AgentKit's `ak secrets` and the migration guide, and still
 *  lists pending agent reveal requests so approve links (`?request=<id>`) keep working (old screen kept in routes/secrets.tsx, not routed) */

import { ExternalLink, KeyRound } from 'lucide-react'
import { useSearchParams } from 'react-router-dom'
import { SecretRevealRequestsPanel } from '../components/secrets/secret-reveal-requests-panel'
import { SECRETS_MOVED_DOCS_URL } from '../components/shell/nav-config'
import { buttonPrimaryClass, cardClass } from '../components/ui/styles'
import { useT } from '../i18n'

const EXPORT_COMMAND = 'agentwiki secrets export --env dev --reveal --reason "move to ak secrets" > dev.env'

export function SecretsMovedPage() {
  const t = useT()
  const [searchParams, setSearchParams] = useSearchParams()
  const highlightId = searchParams.get('request')
  const clearHighlight = (id: string) => {
    if (id !== highlightId) return
    const params = new URLSearchParams(searchParams)
    params.delete('request')
    setSearchParams(params, { replace: true })
  }
  return (
    <div className="mx-auto w-full max-w-2xl space-y-6 px-4 py-6 md:px-8 md:py-10">
      <header className="flex items-start gap-3">
        <KeyRound className="mt-1 h-6 w-6 shrink-0 text-fg-subtle" aria-hidden="true" />
        <h1 className="font-display text-2xl font-semibold tracking-tight text-fg">{t('secrets.moved.title')}</h1>
      </header>
      <SecretRevealRequestsPanel highlightId={highlightId} onDecided={clearHighlight} />
      <section className={`${cardClass} space-y-3 p-5 text-sm text-fg-muted`}>
        <p>{t('secrets.moved.body')}</p>
        <p>{t('secrets.moved.sync')}</p>
        <p>{t('secrets.moved.export')}</p>
        <pre className="overflow-x-auto rounded-md bg-surface-muted p-3 text-xs text-fg">{EXPORT_COMMAND}</pre>
      </section>
      <a href={SECRETS_MOVED_DOCS_URL} target="_blank" rel="noreferrer" className={buttonPrimaryClass}>
        {t('secrets.moved.docs')}
        <ExternalLink className="h-4 w-4" aria-hidden="true" />
      </a>
    </div>
  )
}
